import AccesoAutorizado from './AccesoAutorizado';

export default AccesoAutorizado;
